module.exports = __webpack_public_path__ + "static/crane-9b190631fb2220e35d8576e3bcaeb723.png";